import * as React from "react";
import cn from "classnames";
import styles from "./styles.module.scss";

interface IProps {
    value?: number;
    minValue?: number;
    maxValue?: number;
    className?: string;
    progressBarClassName?: string;
    variant?: "default" | "primary" | "secondary" | "tertiary";
}

export function ProgressBar({
    value = 0,
    minValue = 0,
    maxValue = 100,
    className,
    progressBarClassName,
    variant = "default",
}: IProps) {
    value = Math.min(Math.max(value, minValue), maxValue);
    const percentage = (value - minValue) / (maxValue - minValue);
    const barWidth = `${Math.round(percentage * 100)}%`;

    return (
        <div
            className={cn(
                {
                    [styles.progressBar]: true,
                    [styles.progressBarDefault]: variant === "default",
                    [styles.progressBarPrimary]: variant === "primary",
                    [styles.progressBarSecondary]: variant === "secondary",
                    [styles.progressBarTertiary]: variant === "tertiary",
                },
                className,
            )}
        >
            <div className={cn(styles.progressBarTrack, progressBarClassName)}>
                <div
                    className={styles.progressBarFill}
                    style={{ width: barWidth }}
                />
            </div>
        </div>
    );
}
